<script setup lang="ts">
import { Briefcase, Store, UserRound, Users } from '@lucide/vue';
import FeatureCard from '@/components/marketing/shared/FeatureCard.vue';
import SectionHeading from '@/components/marketing/shared/SectionHeading.vue';
</script>

<template>
    <section id="who-its-for" class="scroll-mt-24 py-16 sm:py-20">
        <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <SectionHeading
                eyebrow="Who it is for"
                title="Built for people who are not marketers."
                description="If marketing is the thing you do after the real work, LaunchStation is for you."
            />

            <div class="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
                <FeatureCard
                    :icon="Store"
                    title="Small businesses"
                    description="Keep a steady presence without hiring an agency or writing posts at midnight."
                />
                <FeatureCard
                    :icon="Briefcase"
                    title="Product and service brands"
                    description="Turn launches, offers and updates into a campaign your customers actually see."
                    tone="secondary"
                />
                <FeatureCard
                    :icon="UserRound"
                    title="Creators and solo marketers"
                    description="Repurpose what you already made into posts for every channel you are on."
                    tone="secondary"
                />
                <FeatureCard
                    :icon="Users"
                    title="Agencies and freelancers"
                    description="Manage several brands from one login, each with its own assistant, voice and calendar."
                />
            </div>
        </div>
    </section>
</template>
